import React, { useEffect, useState } from 'react';
import { createStickerCanvas } from '../utils/stickerUtils';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

export default function PreviewPanel({ previewItem, options }) {
  const [previewUrl, setPreviewUrl] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const renderPreview = async () => {
      if (!previewItem) {
        setPreviewUrl(null);
        return;
      }
      
      const canvas = await createStickerCanvas(previewItem, options);
      if (isMounted) {
        setPreviewUrl(canvas.toDataURL('image/png'));
      }
    };

    const timeoutId = setTimeout(renderPreview, 300);
    return () => {
      isMounted = false;
      clearTimeout(timeoutId);
    };
  }, [previewItem, options]);

  // Вычисляем соотношение сторон для правильного отображения превью
  const aspectRatio = options.stickerWidth / options.stickerHeight;

  return (
    <div className="bg-panelBg rounded-xl border border-gray-800 h-full flex flex-col overflow-hidden sticky top-8">
      <div className="bg-panelCard p-4 border-b border-gray-800 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <SafeIcon icon={FiIcons.FiEye} className="text-accent" />
          <h2 className="font-bold text-sm tracking-widest uppercase">Превью наклейки</h2>
        </div>
        {previewItem && (
          <span className="text-xs bg-[#2a2a2a] px-2 py-1 rounded text-gray-400 font-mono">
            LIVE
          </span>
        )}
      </div>
      
      <div className="flex-1 flex flex-col items-center justify-center p-8 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMiIgY3k9IjIiIHI9IjIiIGZpbGw9IiMzMzMiLz48L3N2Zz4=')]">
        {previewUrl ? (
          <div className="relative group flex items-center justify-center w-full h-full">
            <img 
              src={previewUrl} 
              alt="Sticker Preview" 
              className="max-w-full max-h-[400px] shadow-2xl rounded-sm border border-gray-700 transition-transform transform group-hover:scale-105 object-contain"
              style={{ aspectRatio: aspectRatio }}
            />
            <div className="absolute -bottom-8 left-0 right-0 text-center opacity-0 group-hover:opacity-100 transition-opacity">
              <span className="text-xs text-textMuted bg-mainBg px-3 py-1.5 rounded-full border border-gray-800 font-mono">
                {options.stickerWidth}x{options.stickerHeight} мм
              </span>
            </div>
          </div>
        ) : (
          <div className="text-center text-textMuted flex flex-col items-center gap-3">
            <div className="w-16 h-16 rounded-full bg-inputBg flex items-center justify-center border border-gray-800">
              <SafeIcon icon={FiIcons.FiImage} className="text-2xl text-gray-600" />
            </div>
            <p className="text-sm">Введите корректные ссылки,<br/>чтобы увидеть превью</p>
          </div>
        )}
      </div>
      
      <div className="p-5 border-t border-gray-800 bg-panelCard">
        <div className="flex items-start gap-3">
          <SafeIcon icon={FiIcons.FiInfo} className="text-accent mt-0.5" />
          <div className="text-xs text-gray-400 space-y-2">
            <p><strong className="text-gray-200">Размещение PDF:</strong> При экспорте в PDF алгоритм автоматически центрирует сетку наклеек на листе А4, учитывая заданные вами размеры ({options.stickerWidth}x{options.stickerHeight} мм).</p>
          </div>
        </div>
      </div>
    </div>
  );
}